<template>
  <div class="footer">
    <a class="footer__top" href="#top">Back to top</a>
    <div class="footer__body">
      <div class="container">
        <div class="footer__logo">
          <img src="../../images/footer-logo.png" alt />
        </div>
        <div class="footer__list _support">
          <div class="footer__list__title">Support</div>
          <ul class="footer__list__menu">
            <li class="footer__list__menu__item">
              <a href="/payment_guide">お支払いについて</a>
            </li>
            <li class="footer__list__menu__item">
              <a href="/delivery_guide">配送について</a>
            </li>
            <li class="footer__list__menu__item">
              <a href="/cancel_guide">キャンセルについて</a>
            </li>
          </ul>
        </div>
        <div class="footer__list _about">
          <div class="footer__list__title">About us</div>
          <ul class="footer__list__menu">
            <li class="footer__list__menu__item">
              <a href="/guide">お買い物ガイド</a>
            </li>
            <li class="footer__list__menu__item">
              <a href="/faq">FAQ</a>
            </li>
            <li class="footer__list__menu__item">
              <a href="/inquiries/new">ご質問</a>
            </li>
            <!-- <li class="footer__list__menu__item">
              <a href="/資料請求.pdf" target="_blank">資料請求</a>
            </li> -->
            <li class="footer__list__menu__item">
              <a href="/アカウント開設の手引き.pdf" target="_blank">アカウント開設の手引き</a>
            </li>
          </ul>
        </div>
        <div class="footer__list _contact">
          <div class="footer__list__title">Contact Us</div>
          <ul class="footer__list__menu">
            <li class="footer__list__menu__item">
              <a href="tel:+81363841395">
                <i class="fa fa-fw fa-phone-volume"></i>03-6384-1395
              </a>
            </li>
            <li class="footer__list__menu__item">
              <a href="mailto:info@bloom-brothers.co.jp">
                <i class="fa fa-fw fa-envelope"></i>info@bloom-brothers.co.jp
              </a>
            </li>
            <li class="footer__list__menu__item">
              <a href="#">
                <i class="fa fa-fw fa-map-marker-alt"></i>東京都新宿区四谷四丁目1番
              </a>
            </li>
          </ul>
        </div>
        <!-- <div class="footer__list _subscribe">
        <div class="footer__list__title">Join to Newsletter</div>
        <div class="footer__list__paragraph">
          月に1度、お客様向けの情報発信を行なっております。<br>
          メルマガ会員登録はこちらから。
        </div>
        <div class="footer__list__subscribe">
          <input type="text" class="footer__list__subscribe__input" placeholder="Your Email">
          <button type="button" class="footer__list__subscribe__button">→</button>
        </div>
        </div>-->
      </div>
    </div>
    <div class="footer__menu">
      <div class="container">
        <span class="footer__copyright">© 2019 Bloom Brothers All Rights Reserved</span>
        <ul class="footer__menu__list">
          <li class="footer__menu__list__item">
            <a href="https://bloom-brothers.co.jp/" target="_blank">運営会社</a>
          </li>
          <li class="footer__menu__list__item">
            <a href="/terms">サイト利用規約</a>
          </li>
          <li class="footer__menu__list__item">
            <a href="/privacy_policy">プライバシーポリシー</a>
          </li>
          <li class="footer__menu__list__item">
            <a href="/law">特定商取引法</a>
          </li>
          <li class="footer__menu__list__item">
            <a href="/review_guide">レビューガイドライン</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>